import {Pipe, PipeTransform} from '@angular/core';
import {TypeUtils} from "../utils/type-utils";

@Pipe({
    name: 'searchByProperty',
    standalone: false
})
export class SearchByPropertyPipe implements PipeTransform {

  private static stringify(value: any): string {
    if (!value && [0, false].indexOf(value) === -1) {
      return '';
    }

    return value.toString().toLowerCase();
  }

  transform<T>(items: T[], properties: object): T[] {
    if (!items) {
      return [];
    }

    const nonEmptyProperties: object = {};
    for (const key in properties) {
      if (!properties.hasOwnProperty(key)) {
        continue;
      }

      const value = SearchByPropertyPipe.stringify(properties[key]);
      if (value) {
        nonEmptyProperties[key] = value;
      }
    }
    if (TypeUtils.isEmpty(nonEmptyProperties)) {
      return items.concat();
    }

    return items.filter((item: T) => {
      let validItem: boolean = false;

      for (const key in nonEmptyProperties) {
        if (!nonEmptyProperties.hasOwnProperty(key)) {
          continue;
        }

        const propValue: string = nonEmptyProperties[key];
        const itemPropValue: string = SearchByPropertyPipe.stringify(item[key]);
        if (propValue && itemPropValue && itemPropValue.indexOf(propValue) !== -1) {
          validItem = true;
          break;
        }
      }

      return validItem;
    });
  }

}
